import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourcesEndpointEnum } from '../enums/resources-endpoint.enum';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  startDateSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private readonly baseUrl: string;
  private readonly configUrl: string;
  // private readonly apiPowerBIUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.getSettings("msal.resources.portalAppAPI.resourceUri");
    this.configUrl = this.configService.getSettings("msal.blobStorageConfigSetting");
    // this.apiPowerBIUrl = this.configService.getSettings("msal.resources.portalAppAPI.apiPowerBIUrl");
  }

  get<T>(endpoint: ResourcesEndpointEnum, params?: Record<string, any>, queryParams?: Record<string, any>): Observable<T> {
    return this.http.get(this.createURI(endpoint, params, queryParams)).pipe(
      map((response: object) => response as unknown as T)
    );
  }

  getCollection<T>(endpoint: ResourcesEndpointEnum, params?: Record<string, any>, queryParams?: Record<string, any>): Observable<T[]> {
    return this.http.get(this.createURI(endpoint, params, queryParams), {
      observe: 'response'
    }).pipe(
      map((response: HttpResponse<any>) => {
        if (response.status === 204) {
          return [];
        } else {
          return response.body;
        }
      })
    );
  }

  post<T>(endpoint: ResourcesEndpointEnum, payload: any, params?: Record<string, any>, queryParams?: Record<string, any>): Observable<T> {
    return this.http.post(this.createURI(endpoint, params, queryParams), payload).pipe(
      map((response: object) => {
        return response as unknown as T;
      })
    );
  }

  postBlob(endpoint: ResourcesEndpointEnum, payload: any, params?: Record<string, any>, queryParams?: Record<string, any>): Observable<HttpResponse<Blob>> {
    return this.http.post(this.createURI(endpoint, params, queryParams), payload, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  put<T>(endpoint: ResourcesEndpointEnum, payload: T, params?: Record<string, any>, queryParams?: Record<string, any>): Observable<T> {
    return this.http.put(this.createURI(endpoint, params, queryParams), payload).pipe(
      map((response: object) => {
        return response as unknown as T;
      })
    );
  }

  delete<T>(endpoint: ResourcesEndpointEnum, params?: Record<string, any>, queryParams?: Record<string, any>): Observable<T> {
    return this.http.delete(this.createURI(endpoint, params, queryParams)).pipe(
      map((response: object) => {
        return response as unknown as T;
      })
    );
  }

  getConfiguration<T>(): Observable<T> {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    });

    return this.http.get(this.configUrl, { headers }).pipe(
      map((response: object) => response as unknown as T)
    );
  }

  // postPowerBIReport<T>(reportId: string, payload: T): Observable<T> {
  //   const headers = new HttpHeaders({
  //   'Content-Type': 'application/json',
  //   'Accept': 'application/json'
  // });
  //   return this.http.post(this.apiPowerBIUrl + reportId + '/ExportTo', payload, { headers }).pipe(
  //     map((response: object) => response as unknown as T)
  //   );
  // }

  private createURI(uri: string, params?: Record<string, any>, queryParams?: Record<string, any>): string {
    if (!params && !queryParams) {
      return this.baseUrl + uri;
    }

    var returnValue = this.baseUrl;
    const posisionOfQM = uri.indexOf('?');
    var paramStrings;
    var queryParamStrings;
    if (posisionOfQM > -1) {
      paramStrings = uri.substring(0, posisionOfQM).split('/');
      queryParamStrings = uri.substring(posisionOfQM + 1).split('&');
    }
    else{
      paramStrings = uri.split('/');
      queryParamStrings = uri.split('?')[1]?.split('&') || [];
    }

    if(params) {

      paramStrings.forEach((segment: any, index: number) => {
        if (segment.charAt(0) === ':') {
          paramStrings[index] = params[segment.substr(1)];
        }
      });
      returnValue += paramStrings.join('/');
    }

    if(queryParams && queryParamStrings.length > 0) {
      queryParamStrings.forEach((segment: any, index: number) => {
        var ecPosition = segment.indexOf('=:');
        var queryName = segment.substring(0, ecPosition);
        var query = queryParams[segment.substr(ecPosition + 2)];
        queryParamStrings[index] = segment.substring(0, ecPosition) + '=' + queryParams[segment.substr(ecPosition + 2)];
      });
      returnValue += '?' + queryParamStrings.join('&');
    }

    return returnValue;
  }
}
